'use client';

import { create } from 'zustand';

export type AppView =
  | 'login'
  | 'admin-dashboard'
  | 'officer-dashboard'
  | 'voter-search'
  | 'voter-verify'
  | 'reports'
  | 'report-14a'
  | 'report-15a'
  | 'report-17a'
  | 'report-18a'
  | 'sync-status';

interface AppState {
  currentView: AppView;
  setCurrentView: (view: AppView) => void;
  selectedVoter: Record<string, unknown> | null;
  setSelectedVoter: (voter: Record<string, unknown> | null) => void;
  isOnline: boolean;
  setIsOnline: (online: boolean) => void;
  lastSyncTime: string | null;
  setLastSyncTime: (time: string) => void;
  syncCount: number;
  setSyncCount: (count: number) => void;
  pendingSyncCount: number;
  setPendingSyncCount: (count: number) => void;
  dataDownloaded: boolean;
  setDataDownloaded: (downloaded: boolean) => void;
  syncEnabled: boolean;
  setSyncEnabled: (enabled: boolean) => void;
  syncFrequencyMinutes: number;
  setSyncFrequencyMinutes: (minutes: number) => void;
}

export const useAppStore = create<AppState>((set) => ({
  currentView: 'login',
  setCurrentView: (view) => set({ currentView: view }),

  selectedVoter: null,
  setSelectedVoter: (voter) => set({ selectedVoter: voter }),

  isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
  setIsOnline: (online) => set({ isOnline: online }),

  lastSyncTime: null,
  setLastSyncTime: (time) => set({ lastSyncTime: time }),

  syncCount: 0,
  setSyncCount: (count) => set({ syncCount: count }),

  pendingSyncCount: 0,
  setPendingSyncCount: (count) => set({ pendingSyncCount: count }),

  dataDownloaded: false,
  setDataDownloaded: (downloaded) => set({ dataDownloaded: downloaded }),

  syncEnabled: true,
  setSyncEnabled: (enabled) => set({ syncEnabled: enabled }),

  syncFrequencyMinutes: 30,
  setSyncFrequencyMinutes: (minutes) => set({ syncFrequencyMinutes: minutes }),
}));
